/* eslint-disable react-hooks/exhaustive-deps */
import * as wjcCore from "@grapecity/wijmo"
import * as wjcInput from "@grapecity/wijmo.input"
import * as wjrInput from "@grapecity/wijmo.react.input"
import { Container, Row, Col, Card, Table } from "react-bootstrap"
import { useLocation } from "react-router"
import AlertComponent from "../../../components/AlertComponent"
import { FC, useEffect, useRef, useState } from "react"
import TextInput from "../../../components/InputWrapper/TextInput"
import { useDispatch, useSelector } from "react-redux"
import { AppDispatch } from "../../.."
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { Button } from "react-bootstrap"
import { clearAlert, setAlerts, setWarningAlerts } from "../../../globalStore/alertStore"
import DateInput from "../../../components/InputWrapper/DateInput"
import MasterRegisterFormRow from "../../../components/MasterRegisterFormRow"
import { TWijmoComboBox } from "../../../type/wijmoComponents"
import ComboBox from "../../../components/ComboBox"
import TextAreaInput from "../../../components/InputWrapper/TextAreaInput"
import { 区分分類コード } from "../../../constant/enum/codes"
import { Prompt, useHistory, useParams } from "react-router-dom"
import RadioInput from "../../../components/InputWrapper/RadioInput"
import SikutyosonSearchModal from "../../../components/SearchModal/SikutyosonSearchModal"
import { T市区町村 } from "../../../service/master/sikutyoson/TSikutyoson"
import KubunService from "../../../service/master/kubun/kubunService"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import TenkoService from "../../../service/truckcontrol/tenko/tenkoService"
import { TTenkoDetailUpsertReq, TTenkoDetailInfoGetRes } from "../../../service/truckcontrol/tenko/TTenko"
import { TApiResponse } from "../../../service/TApiResponse"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import { showInfoToast } from "../../../components/CustomToast"
import { RootState } from "../../../globalStore/rootreducer"
import dayjs from "dayjs"
import { e点呼区分, e点呼方法区分 } from "../../../constant/enum/unko"
import CONSTANT from "../../../constant"
import Spinner from "../../../components/Spinner"
import SyainService from "../../../service/master/syain/syainService"
import { TTenkoUrlParam } from "./TenkoRegister"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import BusyoService from "../../../service/master/busyo/busyoService"
import TenkoSikkosyaSearchModal from "../../../components/SearchModal/TenkoSikkosyaSearchModal"

const 点呼方法リスト: Array<{ value: string | undefined; name: string }> = [
  { value: "1", name: "対面" },
  { value: "2", name: "電話" },
  { value: "3", name: "自動" },
]
const 日常点検フラグリスト: Array<{
  value: number | undefined
  name: string
}> = [
  { value: 1, name: "OK" },
  { value: 0, name: "未実施" },
]
const 免許証フラグリスト: Array<{ value: number | undefined; name: string }> = [
  { value: 1, name: "OK" },
  { value: 0, name: "不携帯" },
]
const 酒気帯フラグリスト: Array<{ value: number | undefined; name: string }> = [
  { value: 0, name: "OK" },
  { value: 1, name: "酒気帯" },
]
const 検知器使用フラグリスト: Array<{
  value: number | undefined
  name: string
}> = [
  { value: 1, name: "使用" },
  { value: 0, name: "未使用" },
]
const 疲労疾病フラグリスト: Array<{
  value: number | undefined
  name: string
}> = [
  { value: 0, name: "OK" },
  { value: 1, name: "疲労" },
]
const 睡眠不足フラグリスト: Array<{
  value: number | undefined
  name: string
}> = [
  { value: 0, name: "OK" },
  { value: 1, name: "睡眠不足" },
]

/**
 * 点呼記録
 * @returns
 */
const TenkoEditor: FC<{
  tabChangeHandler: (tabIndex: number) => any
  点呼区分コード: string
  点呼回数: number
  selfTabindex: number
  selectedIndex: number
  setTabReloading: React.Dispatch<React.SetStateAction<boolean>>
}> = (props) => {
  const { zyomuin_id, date: 対象日 } = useParams<TTenkoUrlParam>()
  const { eigyobiStr: 営業日 } = useSelector((state: RootState) => state.date)
  const history = useHistory()
  const location = useLocation<TTenkoDetailInfoGetRes>()

  const { LoginUserInfo: userInfo } = useSelector((state: RootState) => state.user)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // 戻る確認ダイアログ表示フラグ
  const isPrompt = useRef(false)

  //#region  [state]
  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()

  const [kubunLoaded, setKubunLoaded] = useState(false)

  // 天候区分
  const [天候区分ComboBox, set天候区分ComboBox] = useState<TWijmoComboBox<
    T区分マスタ["区分コード"],
    T区分マスタ
  > | null>(null)
  const [天候区分IsLoadEnded, set天候区分IsLoadEnded] = useState<boolean>(false)

  // 指示事項区分
  const [指示事項区分IsLoadEnded, set指示事項区分IsLoadEnded] = useState<boolean>(false)
  const [指示事項区分ComboBox, set指示事項区分ComboBox] = useState<TWijmoComboBox<
    T区分マスタ["区分コード"],
    T区分マスタ
  > | null>(null)

  //登録項目
  const [点呼記録明細ID, set点呼記録明細ID] = useState<number>()
  const [部所ID, set部所ID] = useState<number>()
  const [点呼日, set点呼日] = useState<string | null | undefined>(対象日 ?? 営業日)
  const [実点呼日, set実点呼日] = useState<string | null | undefined>(対象日 ?? 営業日)
  const [点呼曜日, set点呼曜日] = useState<string>()
  const [点呼時刻, set点呼時刻] = useState<string | null | undefined>()
  const [乗務員ID] = useState<number>()
  const [乗務員社員番号, set乗務員社員番号] = useState<string>()
  const [乗務員名, set乗務員名] = useState<string>()
  const [車番, set車番] = useState<string>()
  const [トレーラ車番, setトレーラ車番] = useState<string>()
  const [携帯電話番号, set携帯電話番号] = useState<string>()
  const [点呼記録ID, set点呼記録ID] = useState<number>()
  const [点呼執行者社員番号, set点呼執行者社員番号] = useState<string>()
  const [点呼執行者社員氏名, set点呼執行者社員氏名] = useState<string>()
  const [天候区分コード, set天候区分コード] = useState<string | null>()
  const [点呼アラート区分名称, set点呼アラート区分名称] = useState<string | null>()
  const [点呼記録方法区分コード, set点呼記録方法区分コード] = useState<string>()
  const [点呼記録方法区分名称1, set点呼記録方法区分名称1] = useState<string>()
  const [点呼方法区分コード, set点呼方法区分コード] = useState<string>()
  const [市区町村ID, set市区町村ID] = useState<number>()
  const [団体コード, set団体コード] = useState<string>()
  const [点呼場所名, set点呼場所名] = useState<string>()
  const [日常点検フラグ, set日常点検フラグ] = useState<number>()
  // const [日常点検記事, set日常点検記事] = useState<string>()
  const [免許証フラグ, set免許証フラグ] = useState<number>()
  const [酒気帯フラグ, set酒気帯フラグ] = useState<number>()
  const [AL検知器使用フラグ, setAL検知器使用フラグ] = useState<number>()
  const [AL測定値, setAL測定値] = useState<number>(0)
  const [アルキラー検知データ_ID, setアルキラー検知データ_ID] = useState<number>()
  const [ナブアシスト点呼データ_ID, setナブアシスト点呼データ_ID] = useState<number>()
  const [疲労疾病フラグ, set疲労疾病フラグ] = useState<number>()
  const [睡眠不足フラグ, set睡眠不足フラグ] = useState<number>()
  const [指示事項1区分コード, set指示事項1区分コード] = useState<string | null>()
  const [指示事項1テキスト] = useState<string>()
  const [報告事項テキスト, set報告事項テキスト] = useState<string>()
  const [共通指示事項1区分ID, set共通指示事項1区分ID] = useState<number>()
  const [共通指示事項1テキスト, set共通指示事項1テキスト] = useState<string>()
  const [共通指示事項2テキスト, set共通指示事項2テキスト] = useState<string>()
  const [更新日時, set更新日時] = useState<string>()

  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)
  const [warnMessages, setWarnMessages] = useState<string[]>([])

  // const [is日付変更ConfirmModalShow, setIs日付変更ConfirmModalShow] =
  //   useState(false)
  const [is市区町村ModalShow, setIs市区町村ModalShow] = useState(false)
  const [isConfirmDeleteModalShow, setIsConfirmDeleteModalShow] = useState(false)
  const [部所コード, set部所コード] = useState<string | null>()
  const [is点呼執行者ModalShow, setIs点呼執行者ModalShow] = useState(false)
  //#endregion

  //#region [comboboxState]
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<string, T部所マスタ> | null>(null)
  const [部所IsLoadEnded, set部所IsLoadEnded] = useState<boolean>(false)
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()

  //#endregion

  //#region [method]

  const set市区町村 = (value: T市区町村) => {
    set市区町村ID(value.市区町村ID)
    set団体コード(value.団体コード)
    set点呼場所名(value.市区町村名漢字)
  }

  /**
   * 検索
   */
  const search = async (乗務員ID: string, 日付: string, 点呼区分コード: string) => {
    dispatch(clearAlert()) // アラートを非表示に
    setIsSearching(true)

    try {
      const service = new TenkoService()
      const res: TApiResponse<TTenkoDetailInfoGetRes> = await service.getMeisai({
        乗務員ID: parseInt(乗務員ID!),
        日付: dayjs(日付!).format("YYYY-MM-DD"),
        点呼区分コード: 点呼区分コード!,
        点呼回数: props.点呼回数,
      })
      if (res.data) {
        set点呼記録明細ID(res.data.点呼記録明細ID)
        set部所ID(res.data.部所ID)
        set部所コード(res.data.部所コード)
        set点呼日(res.data.点呼日)
        set実点呼日(res.data.実点呼日)
        set点呼曜日(dayjs(res.data.点呼日).format("dddd"))
        set点呼時刻(dayjs(res.data.点呼時刻).format("HH:mm"))
        set乗務員社員番号(res.data.乗務員社員コード)
        set乗務員名(res.data.乗務員社員名)
        set携帯電話番号(res.data.携帯電話番号)
        set車番(res.data.車番)
        setトレーラ車番(res.data.トレーラ車番)
        if (
          wjcCore.isNullOrWhiteSpace(res.data.点呼執行者コード ?? "") &&
          wjcCore.isNullOrWhiteSpace(res.data.点呼執行者氏名 ?? "")
        ) {
          set点呼執行者社員番号(userInfo.社員コード)
          set点呼執行者社員氏名(userInfo.社員氏名)
        } else {
          set点呼執行者社員番号(res.data.点呼執行者コード)
          set点呼執行者社員氏名(res.data.点呼執行者氏名)
        }

        set点呼方法区分コード(res.data.点呼方法区分コード)
        set点呼記録方法区分コード(res.data.点呼記録方法区分コード)
        set点呼記録方法区分名称1(res.data.点呼記録方法区分名称1)
        set点呼アラート区分名称(res.data.点呼アラート区分名称1)
        set市区町村ID(res.data.市区町村ID)
        set団体コード(res.data.市区町村団体コード)
        set点呼場所名(res.data.点呼場所名)
        set日常点検フラグ(res.data.日常点検フラグ)
        set免許証フラグ(res.data.免許証フラグ)
        set酒気帯フラグ(res.data.酒気帯フラグ)
        setAL検知器使用フラグ(res.data.AL検知器使用フラグ)
        setAL測定値(res.data.AL測定値 ?? 0)
        setアルキラー検知データ_ID(res.data.アルキラー検知データ_ID)
        setナブアシスト点呼データ_ID(res.data.ナブアシスト点呼データ_ID)
        set疲労疾病フラグ(res.data.疲労疾病フラグ)
        set睡眠不足フラグ(res.data.睡眠不足フラグ)
        set指示事項1区分コード(res.data.指示事項1区分コード)
        set報告事項テキスト(res.data.報告事項テキスト)
        set更新日時(res.data.更新日時 ? res.data.更新日時 : "")

        set共通指示事項1区分ID(res.data.共通指示事項1区分ID)
        set共通指示事項1テキスト(res.data.共通指示事項1テキスト)
        set共通指示事項2テキスト(res.data.共通指示事項2テキスト)
      } else {
        let d = new Date()

        // 点呼明細データが存在しない場合
        set部所コード(location?.state?.部所コード ?? undefined)
        set部所ID(location?.state?.部所ID ?? undefined)
        set点呼日(日付)
        set実点呼日(日付)
        set点呼曜日(dayjs(日付).format("dddd"))
        set点呼時刻(dayjs(d.getTime()).format("HH:mm"))
        set乗務員社員番号(location?.state?.乗務員社員コード ?? "")
        set乗務員名(location?.state?.乗務員社員名 ?? "")
        set携帯電話番号(location?.state?.携帯電話番号 ?? "")
        set車番(location?.state?.車番 ?? "")
        setトレーラ車番(location?.state?.トレーラ車番 ?? "")
        set点呼執行者社員番号(userInfo.社員コード)
        set点呼執行者社員氏名(userInfo.社員氏名)
        set点呼方法区分コード(
          [e点呼区分.中間点呼１, e点呼区分.中間点呼２, e点呼区分.中間点呼３].some((e) => e === props.点呼区分コード)
            ? e点呼方法区分.電話
            : undefined
        )
        set点呼記録方法区分コード("")
        set点呼記録方法区分名称1("")
        set市区町村ID(location?.state?.市区町村ID)
        set団体コード(location?.state?.市区町村団体コード ?? "")
        set点呼場所名(location?.state?.市区町村名漢字 ?? "")
        set日常点検フラグ(undefined)
        set免許証フラグ(undefined)
        set酒気帯フラグ(undefined)
        setAL検知器使用フラグ(undefined)
        setAL測定値(0)
        setアルキラー検知データ_ID(undefined)
        setナブアシスト点呼データ_ID(undefined)
        set疲労疾病フラグ(undefined)
        set睡眠不足フラグ(undefined)
        set報告事項テキスト("")

        // 指示事項1をランダムに選択する
        if (区分ItemSource) {
          const 指示事項List = 区分ItemSource.filter((e) => (e.分類コード = 区分分類コード.運行管理_勤怠.指示事項区分))

          if (指示事項List) {
            let ランダム指示事項Number = Math.trunc(指示事項List.length * Math.random())
            let 指示事項Index = ランダム指示事項Number !== 0 ? ランダム指示事項Number - 1 : 0
            const 初期表示指示事項コード = 指示事項List[指示事項Index]?.区分コード
            set指示事項1区分コード(初期表示指示事項コード)
          }
        }
      }

      // ヘッダ取得
      const tenkoRes = await new TenkoService().getHeader({
        点呼日: 日付,
        部所コード: location?.state?.部所コード,
      })
      if (tenkoRes.data != null) {
        set点呼記録ID(tenkoRes.data.点呼記録ID)
        set天候区分コード(tenkoRes.data.天候区分コード)
        set共通指示事項1区分ID(tenkoRes.data.共通指示事項1区分ID)
        set共通指示事項1テキスト(tenkoRes.data.共通指示事項1テキスト ?? "")
        set共通指示事項2テキスト(tenkoRes.data.共通指示事項2テキスト ?? "")
      } else {
        // ヘッダがない場合、前回点呼日の指示事項+1の指示事項設定
        const prevRes = await new TenkoService().getPrevInstruction({
          部所コード: location?.state?.部所コード,
        })
        let 共通指示事項ID = 7501
        if (prevRes.data != null) {
          共通指示事項ID = prevRes.data.共通指示事項1区分ID ?? 7501
        }
        // 区分マスタ検索
        const kubunRes = await new KubunService().getList({
          分類コード: 区分分類コード.運行管理_勤怠.共通指示事項区分,
        })
        set共通指示事項1区分ID(kubunRes.data.filter((d) => d.区分ID === 共通指示事項ID)[0].区分ID ?? "")
        set共通指示事項1テキスト(kubunRes.data.filter((d) => d.区分ID === 共通指示事項ID)[0].名称1 ?? "")
        set共通指示事項2テキスト(kubunRes.data.filter((d) => d.区分ID === 共通指示事項ID)[0].名称2 ?? "")
      }
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false)
    }
  }

  // 社員検索
  const syainSearch = async (社員番号: string) => {
    try {
      const syainRes = await new SyainService().getList({
        社員コード: 社員番号,
      })
      if (syainRes.data.length === 1) {
        set点呼執行者社員氏名(syainRes.data[0].社員氏名)
      } else {
        set点呼執行者社員氏名("")
      }
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false)
    }
  }

  // // 乗務員検索
  // const zyomuinSearch = async (社員番号: string) => {
  //   try {
  //     const zyomuinRes = await new ZyomuinService().getList({
  //       社員コード: 社員番号,
  //     })
  //     if (zyomuinRes.data.length === 1) {
  //       set乗務員ID(zyomuinRes.data[0].乗務員ID)
  //       set乗務員名(zyomuinRes.data[0].社員氏名)
  //       set携帯電話番号(zyomuinRes.data[0].携帯電話番号)
  //       set部所コード(zyomuinRes.data[0].部所コード)
  //     }
  //   } catch (error) {
  //     dispatch(setAlerts(error))
  //   } finally {
  //     setIsSearching(false)
  //   }
  // }

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = async (is日付変更: boolean) => {
    dispatch(clearAlert())
    const errorMessages: string[] = []
    const innerWarnMessages: string[] = []

    if (!点呼時刻) {
      errorMessages.push("点呼時刻は必須入力です。")
    } else {
      if (
        !(
          点呼時刻.match(CONSTANT.TIME_REGEX) ||
          点呼時刻.match(CONSTANT.TIME_REGEX_NOT_COLON) ||
          点呼時刻.match(CONSTANT.TIME_REGEX_THREE_DIGITS)
        )
      ) {
        errorMessages.push("点呼時刻が不正です。")
      }
    }
    if (wjcCore.isNullOrWhiteSpace(点呼執行者社員番号 ?? "") && wjcCore.isNullOrWhiteSpace(点呼執行者社員氏名 ?? "")) {
      errorMessages.push("点呼執行者は必須入力です。")
    }

    /* 個別点呼内容 Start */
    if (点呼方法区分コード == null) {
      innerWarnMessages.push("点呼方法")
    }

    if (props.点呼区分コード === e点呼区分.始業点呼) {
      if (日常点検フラグ == null) {
        innerWarnMessages.push("日常点検")
      }
      if (免許証フラグ == null) {
        innerWarnMessages.push("免許証")
      }
      if (酒気帯フラグ == null) {
        innerWarnMessages.push("酒気帯")
      }
      if (AL検知器使用フラグ == null) {
        innerWarnMessages.push("アルコール検知器")
      }
      if (疲労疾病フラグ == null) {
        innerWarnMessages.push("疲労疾病")
      }
      if (睡眠不足フラグ == null) {
        innerWarnMessages.push("睡眠不足有無")
      }
    }
    if (
      props.点呼区分コード === e点呼区分.中間点呼１ ||
      props.点呼区分コード === e点呼区分.中間点呼２ ||
      props.点呼区分コード === e点呼区分.中間点呼３
    ) {
      if (酒気帯フラグ == null) {
        innerWarnMessages.push("酒気帯")
      }
      if (AL検知器使用フラグ == null) {
        innerWarnMessages.push("アルコール検知器使用")
      }
      if (疲労疾病フラグ == null) {
        innerWarnMessages.push("疲労疾病")
      }
      if (睡眠不足フラグ == null) {
        innerWarnMessages.push("睡眠不足")
      }
    }

    if (props.点呼区分コード === e点呼区分.終業点呼) {
      if (免許証フラグ == null) {
        innerWarnMessages.push("免許証")
      }
      if (酒気帯フラグ == null) {
        innerWarnMessages.push("酒気帯")
      }
      if (AL検知器使用フラグ == null) {
        innerWarnMessages.push("アルコール検知器")
      }
    }
    /* 個別点呼内容 End */

    if (0 < errorMessages.length) {
      dispatch(setWarningAlerts(errorMessages))
      return
    }

    setWarnMessages(innerWarnMessages)
    // warnMessageが存在する場合は備考が何も書いていない場合はエラー
    if (点呼記録明細ID == null && 0 < innerWarnMessages.length && wjcCore.isNullOrWhiteSpace(報告事項テキスト ?? "")) {
      dispatch(
        setWarningAlerts([
          "点呼内容を入力してください。",
          "点呼内容が存在しない場合、その他指示に内容を入力してください。",
        ])
      )
      return
    }

    if (is日付変更) {
      点呼日変更時重複チェック()
    } else {
      setIsConfirmModalShow(true)
    }
  }

  /**
   * 点呼日変更時、変更先の点呼日・点呼区分を取得する
   *
   */
  const 点呼日変更時重複チェック = async () => {}

  /**
   * 送信
   */
  const submit = async () => {
    try {
      await new TenkoService().putTenko(getPutReq())

      switch (props.点呼区分コード) {
        case e点呼区分.始業点呼:
          showInfoToast(`始業点呼${props.点呼回数 > 0 ? props.点呼回数 : ""}登録が完了しました。`)
          break
        case e点呼区分.中間点呼１:
          showInfoToast(`中間点呼${props.点呼回数 > 0 ? props.点呼回数 : ""}登録が完了しました。`)
          break
        case e点呼区分.終業点呼:
          showInfoToast(`終業点呼${props.点呼回数 > 0 ? props.点呼回数 : ""}登録が完了しました。`)
          break
      }
      // 再検索
      search(zyomuin_id, 対象日, props.点呼区分コード)
      props.setTabReloading(true)
      isPrompt.current = false
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  /**
   * 送信データ作成
   */
  const getPutReq = (): TTenkoDetailUpsertReq => {
    let 点呼時刻Text = 点呼時刻 ?? ""
    // 点呼時刻を調整する
    if (点呼時刻 != null) {
      if (点呼時刻.match(CONSTANT.TIME_REGEX_NOT_COLON)) {
        // 時、分の間にコロンを入れる
        点呼時刻Text = 点呼時刻.slice(0, 2) + ":" + 点呼時刻.slice(2)
      } else if (点呼時刻.match(CONSTANT.TIME_REGEX_THREE_DIGITS)) {
        点呼時刻Text = "0" + 点呼時刻.slice(0, 1) + ":" + 点呼時刻.slice(1)
      }
    }

    return {
      // 明細
      点呼記録明細ID: 点呼記録明細ID,
      部所ID: 部所ID,
      点呼日: 点呼日 ?? "",
      実点呼日: 実点呼日 ?? "",
      点呼時刻: 点呼時刻Text,
      乗務員ID: 乗務員ID ?? parseInt(zyomuin_id),
      乗務員社員番号: 乗務員社員番号,
      車番: 車番,
      トレーラ車番: トレーラ車番,
      点呼執行者社員番号: 点呼執行者社員番号,
      点呼執行者社員氏名: 点呼執行者社員氏名,
      点呼区分コード: props.点呼区分コード,
      点呼方法区分コード: 点呼方法区分コード,
      点呼回数: props.点呼回数,
      市区町村ID: 市区町村ID,
      団体コード: 団体コード,
      点呼場所名: 点呼場所名,
      日常点検フラグ: 日常点検フラグ,
      免許証フラグ: 免許証フラグ,
      酒気帯フラグ: 酒気帯フラグ,
      AL検知器使用フラグ: AL検知器使用フラグ,
      AL測定値: AL測定値,
      疲労疾病フラグ: 疲労疾病フラグ,
      睡眠不足フラグ: 睡眠不足フラグ,
      指示事項1区分コード: 指示事項1区分コード ?? undefined,
      指示事項1テキスト: 指示事項1テキスト,
      報告事項テキスト: 報告事項テキスト,
      更新日時: 更新日時 ?? "",
      // ヘッダ
      点呼記録ID: 点呼記録ID,
      天候区分コード: 天候区分コード ?? undefined,
      共通指示事項1区分ID: 共通指示事項1区分ID,
      共通指示事項1テキスト: 共通指示事項1テキスト,
      共通指示事項2テキスト: 共通指示事項2テキスト,
    }
  }

  /**
   * 削除送信前
   */
  const beforeDeleteSubmit = () => {
    setIsConfirmDeleteModalShow(true)
  }

  /**
   * 削除
   */
  const doDelete = async () => {
    try {
      await new TenkoService().delete(点呼記録明細ID!, {
        更新日時: 更新日時!,
      })

      switch (props.点呼区分コード) {
        case e点呼区分.始業点呼:
          showInfoToast(`始業点呼削除が完了しました。`)
          break
        case e点呼区分.中間点呼１:
          showInfoToast(`中間点呼削除が完了しました。`)
          break
        case e点呼区分.終業点呼:
          showInfoToast(`終業点呼削除が完了しました。`)
          break
      }

      // 再検索
      search(zyomuin_id, 対象日, props.点呼区分コード)
      props.setTabReloading(true)
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsConfirmDeleteModalShow(false)
    }
  }

  //#endregion

  //#region [effect]

  //初期設定（一覧から遷移時）
  useEffect(() => {
    set点呼日(対象日)
    set実点呼日(対象日)

    Promise.all([new KubunService().getList(), new BusyoService().getList({})]).then(([区分マスタRes, 部所ListRes]) => {
      区分マスタRes && set区分ItemSource(区分マスタRes.data)
      set部所ItemSource(部所ListRes.data)
      setKubunLoaded(true)
    })
  }, [])

  //初期設定（タブ選択時）
  useEffect(() => {
    if (props.selfTabindex === props.selectedIndex && 指示事項区分IsLoadEnded && kubunLoaded) {
      if (zyomuin_id) {
        search(zyomuin_id, 対象日, props.点呼区分コード)
        // ファイルロード後、戻るボタン押下時に警告が出るように変更
        isPrompt.current = true
      } else {
        // 指示事項1をランダムに選択する
        if (区分ItemSource) {
          const 指示事項List = 区分ItemSource.filter((e) => (e.分類コード = 区分分類コード.運行管理_勤怠.指示事項区分))

          if (指示事項List) {
            let ランダム指示事項Number = Math.trunc(指示事項List.length * Math.random())
            let 指示事項Index = ランダム指示事項Number !== 0 ? ランダム指示事項Number - 1 : 0
            const 初期表示指示事項コード = 指示事項List[指示事項Index]?.区分コード
            set指示事項1区分コード(初期表示指示事項コード)
          }
        }
      }
    }
  }, [props.selfTabindex, props.selectedIndex, props.点呼区分コード, 指示事項区分IsLoadEnded, kubunLoaded])
  //#endregion

  return (
    <>
      <Prompt when={isPrompt.current} message={CONSTANT.MESSAGES.BROWSER_BACK}></Prompt>
      <Container fluid style={{ paddingLeft: "0rem" }}>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <Row>
          <Col>
            <Card className="w-75rem">
              <Spinner searching={isSearching}></Spinner>
              <Card.Body>
                <Table className="form-table">
                  <tbody>
                    <tr>
                      <th className="min-w-10rem">所属部所</th>
                      <td colSpan={4}>
                        <div className="w-15rem">
                          <ComboBox.Busyo
                            placeholder="部所"
                            isRequired={true}
                            isReadOnly
                            itemsSource={部所ItemSource}
                            isLoadEnded={部所IsLoadEnded}
                            setIsLoadEnded={set部所IsLoadEnded}
                            listFilter={(d) => d.運行部所フラグ === 1}
                            selectedValue={部所コード}
                            setSelectedValue={set部所コード}
                            ComboBox={部所ComboBox}
                            setComboBox={set部所ComboBox}></ComboBox.Busyo>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th className="min-w-10rem">
                        乗務員<span className={"required-mark"}>*</span>
                      </th>
                      <td>
                        <div className="input-group">
                          <TextInput
                            style={{ width: "6rem" }}
                            id="乗務員社員番号"
                            name="乗務員社員番号"
                            isReadOnly
                            tabIndex={-1}
                            isRequired={true}
                            value={乗務員社員番号}
                            // autoFocus={true}
                            // onBlur={async (e) => {
                            //   const v = e.currentTarget.value
                            //   zyomuinSearch(v)
                            // }}
                            setValue={(v) => {
                              set乗務員社員番号(v)
                            }}
                            maxLength={4}
                            placeholder="社員番号"
                          />
                          <TextInput
                            id="乗務員名"
                            name="乗務員名"
                            isReadOnly
                            tabIndex={-1}
                            value={乗務員名}
                            setValue={(v) => {}}
                            placeholder="乗務員名"
                          />
                        </div>
                      </td>
                      <th className="min-w-10rem">車番</th>
                      <td colSpan={2}>
                        <div className="input-group">
                          <TextInput
                            style={{ width: "5rem" }}
                            id="車番"
                            name="車番"
                            isReadOnly={点呼記録明細ID != null}
                            value={車番}
                            setValue={(v) => {
                              set車番(v)
                            }}
                            maxLength={4}
                          />
                          <TextInput
                            style={{ width: "5rem" }}
                            isReadOnly={点呼記録明細ID != null}
                            id="トレーラ車番"
                            name="トレーラ車番"
                            value={トレーラ車番}
                            setValue={(v) => {
                              setトレーラ車番(v)
                            }}
                            maxLength={4}
                          />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th className="min-w-10rem">携帯電話番号</th>
                      <td>
                        <TextInput
                          id="携帯電話番号"
                          name="携帯電話番号"
                          isReadOnly
                          tabIndex={-1}
                          value={携帯電話番号}
                          setValue={(v) => {}}
                        />
                      </td>
                      <th className="min-w-10rem">
                        点呼執行者<span className={"required-mark"}>*</span>
                      </th>
                      <td colSpan={2}>
                        <div className="input-group">
                          <TextInput
                            style={{ width: "6rem" }}
                            id="点呼執行者社員番号"
                            isReadOnly={点呼記録明細ID != null}
                            name="点呼執行者社員番号"
                            // isRequired={true}
                            value={点呼執行者社員番号}
                            onBlur={async (e) => {
                              const v = e.currentTarget.value
                              syainSearch(v)
                            }}
                            setValue={(v) => {
                              set点呼執行者社員番号(v)
                            }}
                            maxLength={4}
                            placeholder="社員番号"
                          />
                          <button
                            type="button"
                            onClick={() => {
                              setIs点呼執行者ModalShow(true)
                            }}
                            className="icon-button">
                            <FontAwesomeIcon className="icon-button-inner" icon={faSearch}></FontAwesomeIcon>
                          </button>

                          <TextInput
                            id="点呼執行者社員氏名"
                            name="点呼執行者社員氏名"
                            isReadOnly={!wjcCore.isNullOrWhiteSpace(点呼執行者社員番号 ?? "") || 点呼記録明細ID != null}
                            tabIndex={-1}
                            value={点呼執行者社員氏名}
                            setValue={set点呼執行者社員氏名}
                            maxLength={100}
                          />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th className="min-w-10rem">
                        点呼日<span className={"required-mark"}>*</span>
                      </th>
                      <td>
                        <div className="input-group">
                          <div className="w-10rem">
                            <DateInput
                              id="点呼日"
                              isRequired={true}
                              value={点呼日}
                              isReadOnly
                              setValue={(v) => {
                                set点呼日(v)
                              }}></DateInput>
                          </div>
                        </div>
                      </td>
                      <th className="min-w-10rem">点呼記録方法</th>
                      <td className="align-middle">
                        <div className="input-group h-100">
                          {点呼記録方法区分名称1}{" "}
                          {点呼記録方法区分コード === "2" && (
                            <span>
                              (<>{アルキラー検知データ_ID}</>)
                            </span>
                          )}
                          {点呼記録方法区分コード === "3" && (
                            <span>
                              (<>{ナブアシスト点呼データ_ID}</>)
                            </span>
                          )}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th className="min-w-10rem">
                        点呼日時<span className={"required-mark"}>*</span>
                      </th>
                      <td>
                        <div className="input-group">
                          <div className="w-10rem">
                            <DateInput
                              id="実点呼日"
                              isRequired={true}
                              isReadOnly={点呼記録明細ID != null}
                              value={実点呼日}
                              setValue={(v) => {
                                set実点呼日(v)
                                set点呼曜日(dayjs(v).format("dddd"))
                              }}></DateInput>
                          </div>
                          <div className="w-4rem">
                            <TextInput
                              id="点呼曜日"
                              name="点呼曜日"
                              isRequired={true}
                              isReadOnly
                              tabIndex={-1}
                              value={点呼曜日!}
                              setValue={set点呼曜日}
                            />
                          </div>
                          <div className="w-4rem">
                            <TextInput
                              id="点呼時刻"
                              name="点呼時刻"
                              isRequired={true}
                              isReadOnly={点呼記録明細ID != null}
                              // tabIndex={-1}
                              value={点呼時刻!}
                              setValue={set点呼時刻}
                              maxLength={5}
                            />
                          </div>
                        </div>
                      </td>
                      <th className="min-w-10rem">天候</th>
                      <td>
                        <ComboBox.Kubun
                          className="w-10rem"
                          分類コード={区分分類コード.運行管理_勤怠.天候区分}
                          isLoadEnded={天候区分IsLoadEnded}
                          setIsLoadEnded={set天候区分IsLoadEnded}
                          isEmpty={true}
                          isReadOnly={点呼記録明細ID != null}
                          itemsSource={区分ItemSource}
                          selectedValue={天候区分コード}
                          setSelectedValue={set天候区分コード}
                          ComboBox={天候区分ComboBox}
                          setComboBox={set天候区分ComboBox}></ComboBox.Kubun>
                      </td>
                      <td>
                        {点呼アラート区分名称 != null && 点呼アラート区分名称 !== "" && (
                          <TextInput
                            className="text-danger fw-bold"
                            style={{ width: "10rem" }}
                            id="点呼アラート区分名称"
                            name="点呼アラート区分名称"
                            isReadOnly
                            tabIndex={-1}
                            value={点呼アラート区分名称 ?? ""}
                            setValue={(v) => {}}
                          />
                        )}
                      </td>
                    </tr>
                  </tbody>
                </Table>
                <Container fluid className="register-form">
                  {/* 点呼方法 */}
                  <MasterRegisterFormRow label="点呼方法">
                    <div className="select-button">
                      <RadioInput
                        name={"点呼方法" + props.点呼区分コード + props.点呼回数}
                        setSelectedValue={set点呼方法区分コード}
                        selectedValue={点呼方法区分コード}
                        disabled={点呼記録明細ID != null}
                        radioTitle=""
                        radioBtnList={
                          [e点呼区分.中間点呼１, e点呼区分.中間点呼２, e点呼区分.中間点呼３].some(
                            (e) => e === props.点呼区分コード
                          )
                            ? [
                                {
                                  name: "電話",
                                  value: "2",
                                },
                              ]
                            : 点呼方法リスト
                        }></RadioInput>
                    </div>
                  </MasterRegisterFormRow>
                  {/* 点呼場所 */}
                  <MasterRegisterFormRow label="点呼場所">
                    &emsp;&emsp;&emsp;&emsp;
                    <TextInput
                      style={{ width: "8rem" }}
                      id="団体コード"
                      name="団体コード"
                      isReadOnly
                      tabIndex={-1}
                      value={団体コード}
                      setValue={set団体コード}
                      maxLength={6}
                      placeholder="市区町村CD"
                    />
                    {点呼記録明細ID == null && (
                      <button
                        type="button"
                        onClick={() => {
                          setIs市区町村ModalShow(true)
                        }}
                        className="icon-button">
                        <FontAwesomeIcon className="icon-button-inner" icon={faSearch}></FontAwesomeIcon>
                      </button>
                    )}
                    <TextInput
                      style={{ width: "25rem" }}
                      id="点呼場所名"
                      name="点呼場所名"
                      value={点呼場所名}
                      isReadOnly={点呼記録明細ID != null}
                      setValue={set点呼場所名}
                      maxLength={100}
                      placeholder="点呼場所名"
                    />
                  </MasterRegisterFormRow>
                  {/* 日常点検 */}
                  <MasterRegisterFormRow label="日常点検">
                    <div className="select-button">
                      <RadioInput
                        name={"日常点検フラグ" + props.点呼区分コード + props.点呼回数}
                        disabled={props.点呼区分コード !== e点呼区分.始業点呼 || 点呼記録明細ID != null}
                        setSelectedValue={set日常点検フラグ}
                        selectedValue={日常点検フラグ}
                        radioTitle=""
                        radioBtnList={日常点検フラグリスト}></RadioInput>
                    </div>
                  </MasterRegisterFormRow>
                  {/* 日常点検記事 */}
                  {/* <MasterRegisterFormRow
                    Width={40}
                    label="日常点検記事"
                    remarks={
                      <div>異常ありの場合、記事欄を入力してください</div>
                    }>
                    <TextAreaInput
                      className="w-100"
                      value={日常点検記事 ?? ""}
                      setValue={set日常点検記事}></TextAreaInput>
                  </MasterRegisterFormRow> */}
                  {/* 免許証フラグ */}
                  <MasterRegisterFormRow label="免許証">
                    <div className="select-button">
                      <RadioInput
                        name={"免許証フラグ" + props.点呼区分コード + props.点呼回数}
                        disabled={
                          props.点呼区分コード === e点呼区分.中間点呼１ ||
                          props.点呼区分コード === e点呼区分.中間点呼２ ||
                          props.点呼区分コード === e点呼区分.中間点呼３ ||
                          点呼記録明細ID != null
                        }
                        setSelectedValue={set免許証フラグ}
                        selectedValue={免許証フラグ}
                        radioTitle=""
                        radioBtnList={免許証フラグリスト}></RadioInput>
                    </div>
                  </MasterRegisterFormRow>
                  {/* 酒気帯フラグ */}
                  <MasterRegisterFormRow label="酒気帯">
                    <div className="select-button">
                      <RadioInput
                        name={"酒気帯フラグ" + props.点呼区分コード + props.点呼回数}
                        setSelectedValue={set酒気帯フラグ}
                        disabled={点呼記録明細ID != null}
                        selectedValue={酒気帯フラグ}
                        radioTitle=""
                        radioBtnList={酒気帯フラグリスト}></RadioInput>
                    </div>
                  </MasterRegisterFormRow>
                  <MasterRegisterFormRow label="アルコール検知器">
                    <div className="select-button">
                      <RadioInput
                        name={"AL検知器使用フラグ" + props.点呼区分コード + props.点呼回数}
                        setSelectedValue={setAL検知器使用フラグ}
                        selectedValue={AL検知器使用フラグ}
                        disabled={点呼記録明細ID != null}
                        radioTitle=""
                        radioBtnList={検知器使用フラグリスト}></RadioInput>
                    </div>
                  </MasterRegisterFormRow>
                  <MasterRegisterFormRow label="測定結果">
                    &emsp;&emsp;&emsp;&emsp;
                    <wjrInput.InputNumber
                      style={{ width: "7rem" }}
                      id="AL測定値"
                      name="AL測定値"
                      isFloat={true}
                      value={AL測定値}
                      isReadOnly={点呼記録明細ID != null}
                      setValue={setAL測定値}
                      max={99.9999}
                      min={0}
                      format={"n2"}
                      valueChanged={(c: wjcInput.InputNumber, e: any) => {
                        c.value != null ? setAL測定値(c.value) : setAL測定値(0)
                      }}
                      placeholder="測定値"
                    />
                    <div className="form-label-right">ml</div>
                  </MasterRegisterFormRow>
                  {/* 疲労疾病フラグ */}
                  <MasterRegisterFormRow label="疲労疾病">
                    <div className="select-button">
                      <RadioInput
                        name={"疲労疾病フラグ" + props.点呼区分コード + props.点呼回数}
                        disabled={
                          [e点呼区分.始業点呼, e点呼区分.中間点呼１].find(
                            (コード) => コード === props.点呼区分コード
                          ) == null || 点呼記録明細ID != null
                        }
                        setSelectedValue={set疲労疾病フラグ}
                        selectedValue={疲労疾病フラグ}
                        radioTitle=""
                        radioBtnList={疲労疾病フラグリスト}></RadioInput>
                    </div>
                  </MasterRegisterFormRow>
                  {/* 睡眠不足フラグ */}
                  <MasterRegisterFormRow label="睡眠不足">
                    <div className="select-button">
                      <RadioInput
                        name={"睡眠不足フラグ" + props.点呼区分コード + props.点呼回数}
                        disabled={
                          [e点呼区分.始業点呼, e点呼区分.中間点呼１].find(
                            (コード) => コード === props.点呼区分コード
                          ) == null || 点呼記録明細ID != null
                        }
                        setSelectedValue={set睡眠不足フラグ}
                        selectedValue={睡眠不足フラグ}
                        radioTitle=""
                        radioBtnList={睡眠不足フラグリスト}></RadioInput>
                    </div>
                  </MasterRegisterFormRow>
                  {/* 指示事項区分１ */}
                  <MasterRegisterFormRow Width={40} label="指示事項">
                    <div className="w-40rem">
                      <ComboBox.Kubun
                        isDisabled={props.点呼区分コード !== e点呼区分.始業点呼 || 点呼記録明細ID != null}
                        分類コード={区分分類コード.運行管理_勤怠.指示事項区分}
                        isLoadEnded={指示事項区分IsLoadEnded}
                        setIsLoadEnded={set指示事項区分IsLoadEnded}
                        isAllSelect={false}
                        itemsSource={区分ItemSource}
                        selectedValue={指示事項1区分コード}
                        setSelectedValue={set指示事項1区分コード}
                        ComboBox={指示事項区分ComboBox}
                        setComboBox={set指示事項区分ComboBox}></ComboBox.Kubun>
                    </div>
                  </MasterRegisterFormRow>
                  {/* その他指示 */}
                  <MasterRegisterFormRow Width={40} label="その他指示" remarks={<div>その他指示事項・報告事項</div>}>
                    <TextAreaInput
                      className="w-100"
                      value={報告事項テキスト ?? ""}
                      setValue={set報告事項テキスト}></TextAreaInput>
                  </MasterRegisterFormRow>
                  {/* 共通指示事項１ */}
                  <MasterRegisterFormRow label="共通指示事項" remarks={<div>行動目標</div>}>
                    <TextInput
                      style={{ width: "41rem" }}
                      id="共通指示事項1テキスト"
                      name="共通指示事項1テキスト"
                      value={共通指示事項1テキスト}
                      setValue={set共通指示事項1テキスト}
                      isReadOnly={true}
                    />
                  </MasterRegisterFormRow>
                  {/* 共通指示事項２ */}
                  <MasterRegisterFormRow label="" remarks={<div>防止対策</div>}>
                    <TextInput
                      style={{ width: "41rem" }}
                      id="共通指示事項2テキスト"
                      name="共通指示事項2テキスト"
                      value={共通指示事項2テキスト}
                      setValue={set共通指示事項2テキスト}
                      isReadOnly={true}
                    />
                  </MasterRegisterFormRow>
                </Container>
                <br />
                <Row className="search-button">
                  <Col xl={{ span: "auto", offset: 0 }}>
                    <Button
                      type="submit"
                      disabled={
                        (!乗務員ID && !zyomuin_id) ||
                        !dayjs(対象日).isSame(点呼日, "d") ||
                        (点呼記録明細ID != null && wjcCore.isNullOrWhiteSpace(報告事項テキスト ?? ""))
                      }
                      variant="waiting"
                      onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        beforeSubmit(false)
                      }}>
                      {点呼記録明細ID != null ? `更新` : `登録`}
                    </Button>
                  </Col>
                  <Col>
                    <Button
                      variant="secondary"
                      onClick={(e) => {
                        history.goBack()
                      }}>
                      一覧に戻る
                    </Button>
                  </Col>
                  {/* 削除不可に変更 */}
                  {false && (
                    <Col>
                      <Button
                        variant="caution"
                        onClick={(e) => {
                          e.stopPropagation()
                          e.preventDefault()
                          beforeDeleteSubmit()
                        }}>
                        削除
                      </Button>
                    </Col>
                  )}
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <SikutyosonSearchModal
        isShow={is市区町村ModalShow}
        setIsShow={setIs市区町村ModalShow}
        setData={set市区町村}></SikutyosonSearchModal>
      <TenkoSikkosyaSearchModal
        size="lg"
        isShow={is点呼執行者ModalShow}
        setIsShow={setIs点呼執行者ModalShow}
        setSikkosya={(執行者) => {
          set点呼執行者社員番号(執行者.社員コード)
          set点呼執行者社員氏名(執行者.社員氏名)
        }}></TenkoSikkosyaSearchModal>
      <ConfirmModal isShow={isConfirmModalShow} hideHandler={setIsConfirmModalShow} submitHandler={submit}>
        {点呼記録明細ID == null && warnMessages.length > 0 ? (
          <>
            以下の項目が未入力のため,その他指示のみ反映されます。
            <dd className="mt-1">
              {warnMessages.map((message, index) => (
                <dt className="fw-bold ms-2" key={index}>
                  {message}
                  {/* {index < warnMessages.length - 1 && ",  "} */}
                </dt>
              ))}
            </dd>
            <div>そのまま登録を行いますか？</div>
          </>
        ) : (
          <div>入力された内容で登録しますか？</div>
        )}
      </ConfirmModal>
      <ConfirmModal
        isShow={isConfirmDeleteModalShow}
        hideHandler={setIsConfirmDeleteModalShow}
        submitHandler={doDelete}>
        点呼情報を削除しますか？
      </ConfirmModal>
    </>
  )
}
export default TenkoEditor
